import { configureStore, combineReducers } from "@reduxjs/toolkit";
import attributionSlice, {
  initialState as attributionInitialState,
} from "../attribution";
import productGridSlice, {
  initialState as productGridInitialState,
} from "../productGrid";
import productListSlice, {
  initialState as productListInitialState,
} from "../productList";
import productSectionSlice, {
  initialState as productSectionInitialState,
} from "./slice";
import { ProductSectionView } from "AssortmentOverview/ProductSection/types";
import { ActionSectionIcons } from "AssortmentOverview/ProductSection/Header/ActionSection/types";
import {
  DoorQuantities,
  ProductListRow,
  SizeCurveRatio,
  SizeCurves,
} from "ProductList/types";

export const defaultInitialState: ProductSectionState = {
  attribution: attributionInitialState,
  productGrid: productGridInitialState,
  productList: productListInitialState,
  productSection: productSectionInitialState,
};

type buildStoreArgs = {
  initialState: ProductSectionState;
};

const buildStore = (args?: buildStoreArgs) => {
  const initialState = args?.initialState || defaultInitialState;

  return configureStore({
    preloadedState: initialState,
    reducer: combineReducers({
      attribution: attributionSlice.reducer,
      productGrid: productGridSlice.reducer,
      productList: productListSlice.reducer,
      productSection: productSectionSlice.reducer,
    }),
  });
};

export type RowSelectionData = {
  rowId: string;
  assortmentId: string;
  colorId: string;
  doorId: string;
  skuId: string;
  doorBulk: number;
  door_color_bulk: number;
  doors?: DoorQuantities[];
  size_curves: SizeCurves;
  size_curve_ratios: SizeCurveRatio[];
};

export type ProductSectionState = {
  attribution: ReturnType<typeof attributionSlice.reducer>;
  productGrid: ReturnType<typeof productGridSlice.reducer>;
  productList: ReturnType<typeof productListSlice.reducer>;
  productSection: {
    activeView: ProductSectionView;
    shouldShowDoorsModal: boolean;
    shouldShowImportModal: boolean;
    deleteProductsEnabled: boolean;
    selectedRows: RowSelectionData[];
    rowsDeleted: any[];
    disabledActions: ActionSectionIcons[];
    newStyleColorRows: ProductListRow[];
    workspaceAssistantEnabled: boolean;
  };
};

export default buildStore;
